import EditMerchantAdminForm from '@components/forms/EditMerchantAdminForm';
import { EcoLoader, EcoTab, EcoTabContent, EcoTabs } from '@components/shared';
import { FormFieldsConfig } from '@components/shared/EcoForm';
import EcoScrollView from '@components/views/EcoScrollView';
import { MerchantAdmin } from '@ecocart/entities';
import { BackLink } from '@navigation/BackLink';
import { GlobalScreenProps } from '@navigation/types';
import { useQuery } from '@tanstack/react-query';
import { getMerchantAdmin } from '@utils/api/merchant';
import { EcoCartApiMerchantTabs, EcoCartGlobalMerchantTabs } from '@utils/constants/tabs';
import { View } from 'react-native';

const formFieldsConfig: FormFieldsConfig<Partial<MerchantAdmin>>[] = [
  {
    field: 'pkgReturnEnabled',
    type: 'checkbox',
    label: 'Enable Package Return'
  }
];

export default function MerchantReturnScreen({ route }: GlobalScreenProps): JSX.Element {
  const shopName = route?.params?.shopName;
  const { data: merchantAdmin, refetch } = useQuery(['merchantAdmin', shopName], () => getMerchantAdmin(shopName));
  const EcoCartMerchantTabs = merchantAdmin?.platform === 'api' ? EcoCartApiMerchantTabs : EcoCartGlobalMerchantTabs;

  return (
    <EcoScrollView>
      <View className="flex-row">
        <BackLink href="/merchants" label="Back to Merchants" />
      </View>
      <EcoTabs
        tabs={EcoCartMerchantTabs.map(({ label, screenName }) => {
          return {
            label,
            screenName,
            screenParams: { shopName }
          } as EcoTab;
        })}
        prefix="Merchant"
        activeScreen="MerchantReturn"
      >
        <EcoTabContent title="Edit Package Return Settings">
          {merchantAdmin ? (
            <EditMerchantAdminForm merchantAdmin={merchantAdmin} formFieldsConfig={formFieldsConfig} onSuccess={refetch} />
          ) : (
            <EcoLoader size="large" />
          )}
        </EcoTabContent>
      </EcoTabs>
    </EcoScrollView>
  );
}
